var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 57,
    viewBox: "0 0 65 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7217 51.9276C17.9094 51.9276 11.5763 45.5944 11.5763 37.7821C11.5763 29.9698 17.9094 23.6367 25.7217 23.6367C33.534 23.6367 39.8672 29.9698 39.8672 37.7821C39.8672 45.5944 33.534 51.9276 25.7217 51.9276Z",
    fill: "#0F86A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1992 29.5353C48.9676 29.5353 44.7265 25.2942 44.7265 20.0625C44.7265 14.8309 48.9676 10.5898 54.1992 10.5898C59.4308 10.5898 63.6719 14.8309 63.6719 20.0625C63.6719 25.2942 59.4308 29.5353 54.1992 29.5353Z",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5761 11.4102C8.96031 11.4102 6.83981 9.28967 6.83981 6.67385C6.83981 4.05804 8.96031 1.9375 11.5761 1.9375C14.1919 1.9375 16.3125 4.05804 16.3125 6.67385C16.3125 9.28967 14.1919 11.4102 11.5761 11.4102Z",
    fill: "#1B1B1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5C0 44.2401 12.7599 57 28.5 57C44.2401 57 57 44.2401 57 28.5C57 12.7599 44.2401 0 28.5 0C12.7599 0 0 12.7599 0 28.5ZM55.7883 28.5C55.7883 43.5709 43.5709 55.7883 28.5 55.7883C13.4291 55.7883 1.21166 43.5709 1.21166 28.5C1.21166 13.4291 13.4291 1.21166 28.5 1.21166C43.5709 1.21166 55.7883 13.4291 55.7883 28.5Z",
    fill: "#1B1B1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8623 56.0174C7.63989 56.0174 4.21693 52.5945 4.21693 48.372C4.21693 44.1495 7.63989 40.7266 11.8623 40.7266C16.0848 40.7266 19.5078 44.1495 19.5078 48.372C19.5078 52.5945 16.0848 56.0174 11.8623 56.0174Z",
    fill: "#EBC7B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.72851193dd2101ec227c403cf19f612c.svg";
export { ForwardRef as ReactComponent };